<template>
  <div id="pageTable">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                hide-details
                :placeholder="$t('search')"
                prepend-icon="search"
                solo
                v-model="search"
              ></v-text-field>
              <v-btn small color="primary" @click="sendEmit('create')">{{$t('new')}}</v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="formatList"
                :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                :search="search"
                class="elevation-1"
                item-key="_id"
                :loading="loading"
                :pagination.sync="pagination"
              >
                <template slot="items" slot-scope="props">
                  <td class="justify-center px-0">
                    <v-btn flat icon color="success">
                      <v-icon
                        class="icon material-icons"
                        @click="sendEmit('update', props.item._id)"
                      >create</v-icon>
                    </v-btn>
                    <v-btn flat icon color="error">
                      <v-icon
                        class="icon material-icons"
                        @click="sendEmit('delete', props.item._id)"
                      >delete</v-icon>
                    </v-btn>
                  </td>
                  <td>
                    <i
                      class="success--text icon material-icons"
                      v-if="props.item.active"
                    >check_circle</i>
                    <i class="error--text icon material-icons" v-else>cancel</i>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{props.item.countryId}}</td>
                  <td>{{props.item.createdAt}}</td>
                  <td>{{props.item.createdBy}}</td>
                  <td>{{props.item.updatedAt}}</td>
                  <td>{{props.item.updatedBy}}</td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { dateFormat } from '../../../../helpers/dateHelper'

export default {
  name: 'list',
  data () {
    return {
      search: '',
      pagination: {
        sortBy: 'active',
        descending: true
      },
      complex: {
        headers: [
          {
            text: this.$t('actions'),
            value: ''
          },
          {
            text: this.$t('state'),
            value: 'active'
          },
          {
            text: this.$t('name'),
            value: 'name'
          },
          {
            text: this.$tc('country'),
            value: 'countryId'
          },
          {
            text: this.$t('createdAt'),
            value: 'createdAt'
          },
          {
            text: this.$t('createdBy'),
            value: 'createdBy'
          },
          {
            text: this.$t('updatedAt'),
            value: 'updatedAt'
          },
          {
            text: this.$t('updatedBy'),
            value: 'updatedBy'
          }

        ]
      }
    }
  },
  computed: {
    ...mapState({
      loading: state => state.provinces.loading,
      listCountries: state => state.countries.list,
      listProvinces: state => state.provinces.list,
      listUser: state => state.users.listaUsers
    }),
    formatList () {
      return this.listProvinces.map(province => {
        return {
          ...province,
          countryId: this.formatCountry(province.countryId),
          createdAt: dateFormat(province.createdAt, false),
          createdBy: this.formatUser(province.createdBy),
          updatedAt: dateFormat(province.updatedAt, false),
          updatedBy: this.formatUser(province.updatedBy)
        }
      })
    }
  },
  methods: {
    ...mapActions({
      getOne: 'provinces/setOne'
    }),
    sendEmit (evento, id = null) {
      if (evento !== 'delete' && evento !== 'create' && evento !== 'update') {
        return
      }
      switch (evento) {
        case 'create':
          this.$emit('create')
          break
        case 'update':
          this.getOne(id)
          this.$emit('update')
          break
        case 'delete':
          this.getOne(id)
          this.$emit('remove')
          break
      }
    }
  }
}
</script>

<style scoped>
.success--text {
  color: green;
}

.error--text {
  color: red;
}
</style>
